'use client';
import BlockHeader from '@/components/UIkit/BlockHeader';
import StudyFormatCard from '@/components/StudyFormat/StudyFormatCard';
import StudyFormatCardViolet from './StudyFormatCardViolet';
import { ArrowUpRightIcon } from '@heroicons/react/16/solid';
import { ReactNode, useState } from 'react';
import ModalForm from '../Modal/Modal';
import { SerializedEditorState } from '@payloadcms/richtext-lexical/lexical';
import CustomRichText from '../CustomRichText';

export interface StudyFormatBlockProps {
  id?: string;
  title: ReactNode | SerializedEditorState;
  subtitle?: ReactNode | SerializedEditorState;
  title_2?: ReactNode | SerializedEditorState;
  formatList: Array<{
    title: ReactNode | SerializedEditorState;
    subtitle: ReactNode | SerializedEditorState;
    txtContent: ReactNode | SerializedEditorState;
  }>;
  color?: 'violet' | 'blue' | 'green';
  size?: 'small' | 'large';
  showMoreBtn?: boolean;
  showMoreBtn_v2?: boolean;
  buttonText?: string;
  btnTag?: string;
}
export default function StudyFormatBlock({
  title,
  title_2,
  formatList,
  id,
  subtitle,
  color = 'violet',
  size,
  showMoreBtn = false,
  showMoreBtn_v2 = false,
  buttonText,
  btnTag,
}: StudyFormatBlockProps) {
  const [isFormOpen, setIsFormOpen] = useState(false);

  const openForm = () => setIsFormOpen(true);
  const closeForm = () => setIsFormOpen(false);

  const backgroundColorClass =
    {
      green: 'custom-gradient-green-btn',
      blue: 'custom-gradient-blue-btn',
      violet: 'custom-gradient-violet-btn',
    }[color] || 'custom-gradient-green-btn';
  return (
    <>
      <div
        id={id}
        data-meta="StudyFormatBlock"
        className="container mx-auto px-4 sm:px-6 lg:px-8 my-14"
      >
        <BlockHeader title={title} subtitle={subtitle} />
        {title_2 && (
          <CustomRichText
            data={title_2}
            tag="div"
            className="mt-6 text-xl lg:text-2xl font-bold text-center md:leading-6 lg:leading-8 text-white"
          />
        )}
        <div className="flex justify-center mt-14">
          <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 lg:gap-4 gap-4">
            {formatList.map((item, index) => {
              if (color === 'violet' && size === 'large') {
                return (
                  <StudyFormatCardViolet
                    key={index}
                    subtitle={item.subtitle}
                    title={item.title}
                    txtContent={item.txtContent}
                    index={index}
                    color={'violet'}
                  />
                );
              }
              return (
                <StudyFormatCard
                  key={index}
                  subtitle={item.subtitle}
                  title={item.title}
                  txtContent={item.txtContent}
                  index={index}
                  color={color}
                />
              );
            })}
            {showMoreBtn && (
              <div className="flex items-center justify-center">
                <button
                  onClick={openForm}
                  className={`pl-8 pr-1 py-1 text-lg h-fit font-bold text-white uppercase rounded-full  ring-${color}-500 ring-1 flex gap-2 items-center`}
                >
                  <span className="max-sm:text-sm">{buttonText}</span>
                  <div className={`rounded-full ${backgroundColorClass} p-2`}>
                    <ArrowUpRightIcon className="text-white h-4 w-4" />
                  </div>
                </button>
              </div>
            )}
            {showMoreBtn_v2 && (
              <div className="md:flex items-center justify-center">
                <button
                  onClick={openForm}
                  className={`pl-8 pr-1 py-1 text-lg h-fit font-bold text-white uppercase rounded-full  ring-${color}-500 ring-1 flex gap-2 items-center`}
                >
                  <span className="max-sm:text-sm">{buttonText}</span>
                  <div className={`rounded-full ${backgroundColorClass} p-2`}>
                    <ArrowUpRightIcon className="text-white h-4 w-4" />
                  </div>
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
      {isFormOpen && (
        <ModalForm closeForm={closeForm} btnMeta={{ tag: btnTag ?? '' }} color={color} />
      )}
    </>
  );
}
